import $api from "../http"
import { AxiosResponse } from 'axios'
import { IUser } from "../models/IUser"

export default class UserService {

  static fetchUsers(): Promise<AxiosResponse<IUser[]>> {
    return $api.get<IUser[]>('/users')
  }

  static wsHi(): Promise<AxiosResponse> {
    const message = 'hello WS'
    return $api.post('/ws', { message })
  }

  // `Н48`: поле роли называется `roleId` — как в схеме сервера. Прежнее `roleID`
  // сервер отвергает, и заведение пользователя с сайта падало 400.
  static create(newUserData: { email?: string, tel?: string, password?: string, roleId?: number, companyId?: number, plantId?: number, stationId?: number }): Promise<AxiosResponse<IUser>> {
    return $api.post<IUser>('/user', newUserData);
  }

  static edit(id: number, userData: { tel?: string; email?: string }): Promise<AxiosResponse<IUser>> {
    const params = new URLSearchParams();
    params.append('id', id.toString());

    return $api.put<IUser>(`/user?${params.toString()}`, userData);
  }

}
